module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1206"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1206"
    },
    "bundlingPackage": "LoginUI",
    "bundlingPackageVersion": "static-1.15643",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};